import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";
import App from "../layout/App";
// import Gov from "../layout/gov/Gov";
import SignInCallback from "../layout/SignInCallback";
import SignOutCallback from "../layout/SignOutCallback";
import DoctorOnboarding from "../layout/onboarding/DoctorOnboarding";
import { useState } from "react";
import PatientSpace from "../layout/patient/PatientSpace";
// import ChatInteractions from "../layout/chatbot/ChatInteractions";
import { useParams } from "react-router-dom";
import Dashboard from "../../features/home/Dashboard";
// import CaseImageGallery from '../layout/images/CaseImageGallery';
// import CaseDetection from "../layout/images/CaseDetection";
import EpidemiologyAnalytics from "../layout/analytics/EpidemiologyAnalytics";
import MoleMappingSpaceWrapper from "../layout/molemapping/MoleMappingSpaceWrapper";
// import MoleDetection from "../layout/images/MoleDetection";
// import AnnotationPage from "../layout/images/AnnotationPage";
import ABCDESpace from "../layout/images/abcde/abcdeSpace";
import PatientReport from "../layout/reports/PatientReport";
import AccountManagement from "../layout/account/AccountManagement";
import { useSubscription } from "../hooks/useSubscription";
import RequireSubscription from "./RequireSubscription";

// Mole mapping wrapper component to handle route parameters
const MoleMappingWrapper = () => {
  const { patientId } = useParams();
  return <MoleMappingSpaceWrapper />;
};

// ABCDE Analysis wrapper component to handle route parameters
const ABCDEWrapper = () => {
  const { annotationId } = useParams();
  return <ABCDESpace annotationId={annotationId} />;
};

// Patient Report wrapper component to handle route parameters
const PatientReportWrapper = () => {
  const { patientId } = useParams();
  const { hasActiveSubscription, isAdvanced, isProfessional, hasSubscription,isAdmin, loading:loading2 } = useSubscription();

  return <PatientReport />;
};

export const routes: RouteObject[]=[
    {
        path:'/',
        element:<App/>,
        children:[
           


            {path:'/', element:<Dashboard/>},
             {path:"/signin-oidc", element:<SignInCallback/>},
            {path:"/signout-callback-oidc", element:<SignOutCallback/>},
                        {path:'/account', element:<AccountManagement/>},
                        // 🔒 Subscription-required routes (any active subscription)
                        {path:"/patients", element:<PatientSpace/>},
                         {path:'/molemapping', element:<MoleMappingSpaceWrapper />},
            {path:'/molemapping/:patientId', element:<MoleMappingWrapper />},
            
            // ABCDE Analysis routes
            {path:'/abcde', element:<ABCDESpace />},
            {path:'/abcde/:annotationId', element:<ABCDEWrapper />},

            // Patient Report routes
            {path:'/patient-report/:patientId', element:<PatientReportWrapper />},
            {
              element: <RequireSubscription/>,
              children: [

            
                        // {path:"/cases/:id", element:<CaseWrapper />},
            {path:'/DoctorOnboarding',element:<DoctorOnboarding/>},
            {path:'/EpidemiologyAnalytics',element:<EpidemiologyAnalytics/>},

            // New routes for Mole Mapping
           ]
            },
          

            // {path:'gov/', element:<Gov/>},

            //externals
            
            // not-found

            {path:'*', element:<Navigate replace to='/'/>}
        ]
    }
];

export const router =createBrowserRouter(routes);

